// import { toTitleCase } from "../../../../utilities/functions";
import styles from "./MetricsColumn.module.css"
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';

const MetricsColumn = (props) => {
    const data = props.data;
    let currentStatus;
    if (data?.status === 'approved'){
        currentStatus = <span><strong>Status:</strong> Approved {<CheckCircleRoundedIcon sx={{ color: 'rgb(25, 135, 84)' }}/>}</span>
    } else if (data?.status === 'rejected') {
        currentStatus = <span><strong>Status:</strong> Rejected {<CancelRoundedIcon sx={{ color: 'rgb(220, 53, 69)' }}/>}</span>
    } else if (data?.status === 'previously approved') {
        currentStatus = <span><strong>Status:</strong> Previously Approved {<CheckCircleRoundedIcon sx={{ color: 'rgb(25, 135, 84)' }}/>}</span>
    } else if (data?.status === 'previously rejected') {
        currentStatus = <span><strong>Status:</strong> Previously Rejected {<CancelRoundedIcon sx={{ color: 'rgb(220, 53, 69)' }}/>}</span>
    } else {
        currentStatus = <span><strong>Status:</strong> Pending Approval {<ErrorRoundedIcon sx={{ color: 'rgb(255, 193, 7)' }} />}</span>
    }

    return (

        <div className={styles.MetricsColumn}>                
                <span><strong>SKU Name Score:</strong> {(data?.similarity_score_sku_name * 100).toFixed(2)}%</span>
                <span><strong>Brand Score:</strong> {(data?.similarity_score_brand * 100).toFixed(2)}%</span>
                <span><strong>Price Score:</strong> {(data?.similarity_score_price * 100).toFixed(2)}%</span>
                <span><strong>Match Source:</strong> {data?.match_source}</span>
                <span><strong>Search Term:</strong> {data?.search_term}</span>
                <span>{currentStatus} {data?.changed ? "(Not Saved)" : ""}</span>
                {/* {data?.ai_suggestion && <span>{geminiStatus} ({data?.ai_confidence})</span>} */}
                <span><strong>Save Type:</strong> {data?.save_type}</span>
        </div>

    )
};

export default MetricsColumn;